import React, { useContext, useState } from 'react';
import uniqid from 'uniqid';
import GitHubIcon from '@material-ui/icons/GitHub';
import LaunchIcon from '@material-ui/icons/Launch';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

import { ThemeContext } from '../../contexts/theme';
import { countdowndesktop, cuppydesktop, firebasechat, meowvoff, mixitapp, reactlabD, reactlabL, trackid, ytvideoplayer, bubbleB, bubbleW, clockB, clockW, coffeeB, coffeeW, flaskB, flaskW, pawB, pawW, recipeB, recipeW, videoB, videoW, vinylB, vinylW } from '../../assets/projects/index';
import './ProjectContainer.css';

/* ------------------------- component ------------------------- */
const ProjectContainer = ({ project }) => {
  const [{ themeName }] = useContext(ThemeContext);

  const [isOpen, setIsOpen] = useState(false);
  const [imgIndex, setImgIndex] = useState(0);

  return (
    <div className='project'>

      <div className='imagem'>
        {project.name.includes('TrackId') ? (
          <img alt='project 1' src={trackid} className='project-img' />
        ) : null}
        {project.name.includes('Meow') ? (
          <img alt='project 2' src={meowvoff} className='project-img' />
        ) : null}
        {project.name.includes('Re@ct') ? (
          <img alt='project 3' src={themeName === 'dark' ? (reactlabL) : (reactlabD)} className='project-img' />
        ) : null}
        {project.name.includes('Youtube') ? (
          <img alt='project 4' src={ytvideoplayer} className='project-img' />
        ) : null}
        {project.name.includes('Mix') ? (
          <img alt='project 5' src={mixitapp} className='project-img' />
        ) : null}
        {project.name.includes('Firebase') ? (
          <img alt='project 6' src={firebasechat} className='project-img' />
        ) : null}
        {project.name.includes('Countdown') ? (
          <img alt='project 7' src={countdowndesktop} className='project-img' />
        ) : null}
        {project.name.includes('Cuppy') ? (
          <img alt='project 8' src={cuppydesktop} className='project-img' />
        ) : null}
        <div className='preview-div'>
          {project.images && (
            <button type='button' onClick={() => setIsOpen(true)} className='preview-img'>Preview</button>
          )}
          {isOpen && <Lightbox
            imageTitle={project.images[imgIndex].title}
            imageCaption={project.images[imgIndex].caption}
            mainSrc={project.images[imgIndex].url}
            nextSrc={project.images[(imgIndex + 1) % project.images.length].url}
            prevSrc={project.images[(imgIndex + project.images.length - 1) % project.images.length].url}
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() => setImgIndex((imgIndex + project.images.length - 1) % project.images.length)}
            onMoveNextRequest={() => setImgIndex((imgIndex + 1) % project.images.length)}
          />}
        </div>
        <h3>
          {project.name}
          {project.name.includes('TrackId') ? (
            <img alt='paw icon' src={themeName === 'dark' ? (vinylW) : (vinylB)} className='project-icon' />
          ) : null}
          {project.name.includes('Meow') ? (
            <img alt='paw icon' src={themeName === 'dark' ? (pawW) : (pawB)} className='project-icon' />
          ) : null}
          {project.name.includes('Re@ct') ? (
            <img alt='chemistry flask icon' src={themeName === 'dark' ? (flaskW) : (flaskB)} className='project-icon' />
          ) : null}
          {project.name.includes('Youtube') ? (
            <img alt='film reel icon' src={themeName === 'dark' ? (videoW) : (videoB)} className='project-icon' />
          ) : null}
          {project.name.includes('Mix') ? (
            <img alt='cook hat icon' src={themeName === 'dark' ? (recipeW) : (recipeB)} className='project-icon' />
          ) : null}
          {project.name.includes('Firebase') ? (
            <img alt='chat bubble icon' src={themeName === 'dark' ? (bubbleW) : (bubbleB)} className='project-icon' />
          ) : null}
          {project.name.includes('Countdown') ? (
            <img alt='sand clock icon' src={themeName === 'dark' ? (clockW) : (clockB)} className='project-icon' />
          ) : null}
          {project.name.includes('Cuppy') ? (
            <img alt='coffee cup icon' src={themeName === 'dark' ? (coffeeW) : (coffeeB)} className='project-icon' />
          ) : null}
        </h3>
      </div>

      <div className='content'>
        <p className='project-description'>{project.description}</p>
        {project.stack && (
          <ul className='project-stack'>
            {project.stack.map((item) => (
              <li key={uniqid()} className='project-stack-item'>
                {item}
              </li>
            ))}
          </ul>
        )}
        {project.sourceCode && (
          <a
            href={project.sourceCode}
            target="_blank"
            rel="noopener noreferrer"
            aria-label='source code'
            className='link link-icon'
          >
            <GitHubIcon />
          </a>
        )}
        {project.livePreview && (
          <a
            href={project.livePreview}
            target="_blank"
            rel="noopener noreferrer"
            aria-label='live preview'
            className='link link-icon'
          >
            <LaunchIcon />
          </a>
        )}
      </div>

    </div>
  )
};

export default ProjectContainer;
